import { Checkbox, CheckboxProps } from '@mantine/core'

export default function SaleInput({ ...props }: CheckboxProps) {
  return <Checkbox label="Wyprzedaż" {...props} />
}
